import { ExpandMore } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useFormHandlerContext } from "../../../controllers/formController";
import StatusMetadataChip from "./StatusMetadataChip";

interface AttributeFieldActionsProps {
  name: string;
}

const AttributeFieldActions: React.FC<AttributeFieldActionsProps> = ({
  name,
}) => {
  const {
    isMetadataFieldVisible,
    toggleMetadataFieldVisibility: toggleMetadataField,
  } = useFormHandlerContext();
  const metadataVisible = isMetadataFieldVisible(name);

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <StatusMetadataChip name={name} show={!metadataVisible} />
      <Tooltip title={metadataVisible ? "Hide Metadata" : "Show Metadata"}>
        <IconButton
          size="small"
          color="primary"
          onClick={() => toggleMetadataField(name)}
          sx={{
            padding: 0.5,
            transition: "transform 0.3s ease",
            transform: metadataVisible ? "rotate(180deg)" : "rotate(0deg)",
            right: 0,
            top: 0,
          }}
        >
          <ExpandMore fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default AttributeFieldActions;
